import PubSub from "underpub-js";
import gsap from "gsap";

var VideoEmbed = function (options) {

  this.options = {
    $el: false,
    baseClass: 'el-VideoEmbed',
  };

  $.extend(true, this.options, options);

};

VideoEmbed.prototype.init = function () {

  var self = this;

  self.$overlay = self.options.$el.find(
    `.${self.options.baseClass}__overlay`,
  );
  self.$image = self.options.$el.find(
    `.${self.options.baseClass}__image`,
  );
  self.$button = self.options.$el.find(`.${self.options.baseClass}__button`);
  self.$embed = self.options.$el.find(`.${self.options.baseClass}__embed`);
  self.$iframe = self.$embed.find('iframe');
  self.iframeSrc = self.$iframe.attr('src');

  self.handleVideoPlay();
};

VideoEmbed.prototype.handleVideoPlay = function () {
  const self = this;

  const timeline = gsap
    .timeline({
      paused: true,
      defaults: {
        ease: 'expo.out',
        duration: 1
      }
    })
    .to(self.$button, {
      opacity: 0,
      yPercent: 100,
      ease: 'expo.out',
      duration: .25,
    })
    .to(
      self.$overlay, {
        autoAlpha: 0,
      },
    )
    .to(
      self.$image, {
        autoAlpha: 0,
      },
      '<',
    )
    .to(self.$embed, {
      opacity: 1
    }, "<")
    .add(() => {
      self.$iframe.attr('src', `${self.iframeSrc.replace(`autoplay=0`, `autoplay=1`)}`);
    }, '<');

  self.$button.on('click', () => timeline.play());
}

export default VideoEmbed;